import React, { useEffect, useRef, useState } from 'react';
import { GameView, gameViewKey } from './components/View/GameView';
import { MainMenuView, mainMenuViewKey } from './components/View/MainMenuView';
import { LevelSelectionView, levelSelectionViewKey } from './components/View/LevelSelectionView';
import { Level, level2 } from './domain/level';
import { Paw } from './components/Common/Paw';
import { SettingsView, settingsViewKey } from './components/View/SettingsView';
import { preload, useLoader, loadableResources } from './util/loader';
import { round } from './util/number';
import music from './assets/music/Level.wav';
import { useSetting } from './hooks/useSetting';

const availableViews = [
    mainMenuViewKey,
    gameViewKey,
    levelSelectionViewKey,
    settingsViewKey,
] as const;

function App() {
    const [ view, setView ] = useState<typeof availableViews[number]>(availableViews[0]);
    // const [ view, setView ] = useState<typeof availableViews[number]>(availableViews[1]);
    const [ level, setLevel ] = useState<Level|null>(null);
    // const [ level, setLevel ] = useState<Level|null>(level2);
    const [ playMusic ] = useSetting('playMusic', true);
    const [ musicVolume ] = useSetting('musicVolume', 20);
    const audioRef = useRef<HTMLAudioElement>();

    useEffect(() => {
        const audio = new Audio(music);
        audio.preload = 'auto';
        audio.loop = true;
        audioRef.current = audio;
    }, []);

    const showView = (view: typeof availableViews[number]) => () => {

        setView(view);
    };
    const handleLevelSelection = (level: Level) => {
        setView(gameViewKey);
        setLevel(level);
    };

    useEffect(() => {
        if (playMusic && level !== null) {
            // eslint-disable-next-line no-empty-function,@typescript-eslint/no-empty-function
            audioRef.current?.play().catch((e) => {});
        } else {
            audioRef.current?.pause();
        }

        return () => {
            audioRef.current?.pause();
        };
    }, [ playMusic ]);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = musicVolume / 100;
        }
    }, [ musicVolume ]);

    const [ loaded, loadingProgress ] = useLoader(loadableResources);

    if (!loaded) {
        return (
            <div className="App">
                <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p aria-live="polite">
                        Loading {round(loadingProgress * 100)}%
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="App">
            <Paw/>
            {view === mainMenuViewKey && (
                <MainMenuView
                    onShowLevelSelection={showView(levelSelectionViewKey)}
                    onShowSettings={showView(settingsViewKey)}
                    onShowCredits={showView(gameViewKey)}
                />
            )}
            {view === levelSelectionViewKey && (
                <LevelSelectionView
                    onSelectLevel={handleLevelSelection}
                    onShowMenu={showView(mainMenuViewKey)}
                />
            )}
            {view === gameViewKey && level !== null && (
                <GameView
                    level={level}
                    onShowMenu={showView(mainMenuViewKey)}
                />
            )}
            {view === settingsViewKey && (
                <SettingsView
                    onShowMenu={showView(mainMenuViewKey)}
                />
            )}
        </div>
    );
}

export default App;
